import platform from '@play-co/gcinstant';
import StateObserver from 'src/StateObserver';
import {
  SceneID,
  startSceneTransition,
  overwritePreviousScene,
} from 'src/state/ui';
import statePromise from './statePromise';
import { LaunchSceneID } from './analytics/properties';
import { Pet } from '../replicant/buruburu/pet';

export function platformFriends(): readonly string[] {
  return platform.friendIds;
}

/**
 * Is this userID is friend of current player
 */
export function isPlayerFriend(userId: string) {
  return platformFriends().includes(userId);
}

export function getLaunchScene(): LaunchSceneID {
  const { user } = StateObserver.getState();
  if (
    Pet.getters(user).getPetState(StateObserver.now(), false) === 'sleeping'
  ) {
    return 'bedroom';
  }
  return 'livingRoom';
}

export function reloadScene() {
  const { previousScene, nextScene } = StateObserver.getState().ui.transition;
  StateObserver.dispatch(startSceneTransition('' as SceneID));
  StateObserver.dispatch(startSceneTransition(nextScene));
  void statePromise(
    (state) => state.ui.transition.phase === 'entered',
  ).then(() => StateObserver.dispatch(overwritePreviousScene(previousScene)));
}

export function getCurrentScene() {
  const transition = StateObserver.getState().ui.transition;
  const { previousScene, nextScene, phase } = transition;
  return phase === 'leaving' ? previousScene : nextScene;
}

export function getNextScene() {
  return StateObserver.getState().ui.transition.nextScene;
}

export function getPreviousScene() {
  return StateObserver.getState().ui.transition.previousScene;
}

export const isCurrentScene = (scene: SceneID) => {
  return getCurrentScene() === scene;
};

export function isTransitioning() {
  const { phase } = StateObserver.getState().ui.transition;
  return phase !== 'entered';
}

export function isSceneEntering(scene: SceneID) {
  const { transition } = StateObserver.getState().ui;
  return transition.nextScene === scene && transition.phase === 'entering';
}

export function isSceneEntered(scene: SceneID) {
  const { transition } = StateObserver.getState().ui;
  return transition.nextScene === scene && transition.phase === 'entered';
}

export function isSceneLeaving(scene: SceneID) {
  const { transition } = StateObserver.getState().ui;
  return transition.previousScene === scene && transition.phase === 'leaving';
}

export function isSceneLeft(scene: SceneID) {
  return getCurrentScene() !== scene;
}

export function isActionSequenceWorking() {
  return StateObserver.getState().ui.actionSequenceWorking;
}

// purchases

export function hasUserPurchasedAnything(): boolean {
  const history = StateObserver.replicant.getPurchaseHistory();
  return history.length > 0;
}
